export default __webpack_public_path__ + "bae78c3.png";